import { BusMessage, MessageFactory, BOOLEAN_BYTES_PER_ELEMENT } from "flavr-common";
export class LoadingSpinnerMessage extends BusMessage {
    get byteLength() {
        return BOOLEAN_BYTES_PER_ELEMENT;
    }
    constructor(show) {
        super();
        this.show = show;
    }
    serialization(stream) {
        this.show = stream.boolean(this.show);
    }
    static is(msg) {
        return msg.type === LoadingSpinnerMessage.typestatic;
    }
}
LoadingSpinnerMessage.typestatic = "LoadingSpinnerMessage";
LoadingSpinnerMessage.subjectstatic = "general";
MessageFactory.register(LoadingSpinnerMessage);
